var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "field is-grouped is-grouped-multiline" },
    [
      _vm.isHide === false
        ? _c(
            "b-select",
            {
              attrs: { placeholder: _vm.$t("msg.pleaseSelect") },
              on: {
                input: function ($event) {
                  return _vm.updateValue($event, _vm.parentCategorySlug)
                },
              },
              model: {
                value: _vm.cateSlug,
                callback: function ($$v) {
                  _vm.cateSlug = $$v
                },
                expression: "cateSlug",
              },
            },
            [
              _vm.isLoading === false
                ? _c("option", { attrs: { value: "" } }, [
                    _vm._v(_vm._s(_vm.$t("msg.pleaseSelect"))),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.categories, function (cate) {
                return _c(
                  "option",
                  { key: cate.slug, domProps: { value: cate.slug } },
                  [_vm._v(_vm._s(cate.label))]
                )
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("b-loading", {
        attrs: { "is-full-page": false },
        model: {
          value: _vm.isLoadingLocal,
          callback: function ($$v) {
            _vm.isLoadingLocal = $$v
          },
          expression: "isLoadingLocal",
        },
      }),
      _vm._v(" "),
      _vm.cateSlug
        ? _c("category-select-recursive", {
            attrs: { "parent-category-slug": _vm.cateSlug },
            on: {
              input: function ($event) {
                return _vm.updateValue($event, _vm.cateSlug)
              },
            },
            model: {
              value: _vm.inputtedValue,
              callback: function ($$v) {
                _vm.inputtedValue = $$v
              },
              expression: "inputtedValue",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }